import { useRef, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { matchPath } from 'app/router/Routes'

export function usePreviousRoute(routes) {
  const location = useLocation()
  const prevLocationRef = useRef(location)

  const [previous, setPrevious] = useState({
    path: null,
    name: null
  })

  useEffect(() => {
    setPrevious({
      path: prevLocationRef.current.pathname,
      name: routes.find(r => matchPath(r.path, prevLocationRef.current.pathname))?.label ?? null
    })
    prevLocationRef.current = location
  }, [location, routes])

  return previous
}
